import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import RadioGroup from '@mui/material/RadioGroup';
import MuiDivider from '@mui/material/Divider';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  }
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.getContrastText(theme.palette.secondary.main)
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  backgroundColor: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: '1fr 2fr',
  padding: theme.spacing(3),
  '& > h6': {
    marginTop: theme.spacing(1) * 0.75
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'auto'
  }
}));

export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export const Divider = styled(MuiDivider)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.common.black
}));
